export default {
  LandingPage: {
    intro_sub:
      'S našimi eko krabicemi chráníte životní prostředí.',
    title: 'Samsung Upcycle-Packaging',
    sequence1_1: 'Přidejte se k nám a snižte množství produkovaného odpadu s ekologickými obaly, které přetváříme na užitečné věci.',
    sequence1_2:
      'S ekologickými krabicemi, které přetváříme na užitečné věci udělejte první krok a scrolujte níže.',
    sequence2_1: 'Představujeme Samsung Upcycle-Packaging',
    sequence2_2:
      'Krabice produkt speciálně narvhnutá k recyklaci s minimálním dopadem na životní prostředí. Vytvořte si z použitého obalu různé předměty pro vaši domácnost.',
    sequence3_1: 'Sledujte natištěné tečky na balení',
    sequence3_2:
      'Vyřezejte vyznačené body na balení a vytvořte tak jedinečný předmět.',
    sequence4_1: 'Vyberte předmět, který chcete vytvořit',
    sequence4_2:
      'Scrolujte níže a vyberte model produkt, který vlastníte. Následně zjistíte, jaký předmět můžete z balení vytvořit. Uspokojte svou zvědavost po nových a unikátních věcech.',
    selectBox: 'Vyberte produkt',
    moreActivity:
      "Pro více informací a trvale udržitelných aktivitách společnosti Samsung",
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'UHD', //update
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'The Frame', //update
    theSerif: 'The Serif', //update
    theSero: 'The Sero', //update
    theTerrace: 'The Terrace', //update
    thePremiere: 'The Premiere', //update
    Monitors: 'Monitory', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Soundbary série Q', //update
    Soundbar: 'Soundbar', //update
    SoundbarSet01:'Soundbar Set 1',
    SoundbarSet02:'Soundbar Set 2',
    TheTerraceSoundbar:'The Terrace\n Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jer&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink:
    //   'https://www.samsung.com/cz/sustainability/overview/',
    //moreActivityLink:'https://www.samsung.com/cz/aboutsamsung/sustainability/strategy/',
    moreActivityLink: 'https://www.samsung.com/cz/sustainability/overview/',
    footer: `
    Copyright© 2019-2021 Samsung. Všechna práva vyhrazena.`,
  },
  ProductPage: {
    selectDesign: 'Vyberte design',
    selectDesignDezeen: 'Samsung X Dezeen', //update
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: 'TV stolek',
    StorageBox: 'Krabice na věci',
    MagazineRack: 'Stojan na časopisy',
    CatHouse: 'Domeček pro kočky',
    CatTunnel: 'Tunel pro kočky',
    BookShelf: 'Police na knihy',
    DeskShelf: 'Police na stůl',
    BlackRhino: 'Ohrožené zvíře - nosorožec černý', //update
    PolarBear: 'Ohrožené zvíře - lední medvěd', //update
    SeaTurtle: 'Ohrožené zvíře - kadeta obrovská', //update
    TheRider: 'Houpací kůň', //update
    Kibe: 'Schody', //update
    Tessellate: 'Konferenční stolek', //update
    Twist: 'Krabice - Twist', //update
    AlexCouchArmTable: 'Alex Couch \n Arm Table', //update
    BlastOffClubHouse: 'Domeček', //update
    KinokoTable: 'Stolek Kinoko', //update
    Magnuss: 'Magnuss', //update
    GIO: 'Stolek Gio', //update
    PostCardPlanter: 'Stojan na pohlednice', //update
    SneakerRack: 'Botník', //update
    TheSoban: 'Stolička Soban', //update
    ToolBox: 'Krabice na nářadí', //update
    DeskStationary: 'Papírnictví',
    CoinBank: 'Pokladnička',
    MobileScanner:'Stojan na telefon',
    TabletScanner:'Stojan na tablet',
    PetStairs:'Schody pro domácí mazlíčky',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: 'minuty',
    all:'ALL',
    in: 'v',
    inOnly: 'jen v',
    allBoxSize: 'Všechny rozměry krabic',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: 'instrukce',
    prepare: 'Připravte si krabici',
    LetsDesign: "Pojďme na to",
    drawParts: 'Nakreslete jednotlivé části na krabici',
    note1: 'Rozměry krabic se mohou lišit v závislosti na velikosti a krajině.',
    note2: 'Ujistěte se, že celá kresba se vejde na krabici.',
    numberSpace: 'číslo=prázné místo mezi tečkami',
    diagonal: 'úhlopříčka',
    LEFT: 'LEVÁ ČÁST',
    RIGHT: 'PRAVÁ ČÁST',
    TOP: 'VRCHNÍ ČÁST',
    TOP1: 'VRCHNÍ ČÁST 1',
    TOP2: 'VRCHNÍ ČÁST 2',
    BACK: 'ZADNÍ ČÁST',
    MIDDLE: 'PROSTŘEDNÍ ČÁST',
    MIDDLE2: 'PROSTŘEDNÍ ČÁST 2',
    BOTTOM: 'SPODNÍ ČÁST',
    FRONT: 'PŘEDNÍ ČÁST',
    SIDE: 'BOČNÍ ČÁST',
    secondSIDE: 'DRUHÁ STRANA',
    secondSIDE1: 'DRUHÁ STRANA 1',
    secondSIDE2: 'DRUHÁ STRANA 2',
    LEG: 'NOHA', //update
    JOINT: 'KLOUB', //update
    FACE: 'TVÁŘ', //update
    DRAWERBOTTOM: 'DNO ZÁSUVKY', //update
    DRAWERSIDE: 'STRANA ZÁSUVKY', //update
    NOSE: 'NOS', //update
    HANDLE: 'DRŽÁK', //update
    BOTTOMSIDE: 'SPODNÍ ČÁST', //update
    TOPSIDE: 'VRCHNÍ ČÁST', //update
    WING: 'KŘÍDLO', //update
    cutAndAssemble: "Vyřízníte a složte",
    beCareful: 'Buďte opatrní a neporaňte se při manipulaci s nástrojem na stříhání či řezaní.',
    cutOutParts: 'Vyřízněte vyznačené části',
    assemble: 'Složte',
    Assemblyguide: 'Manuál na složení', //update
    fold: 'Vzor skládání',
    foldGuide: 'Při ohýbání lepenky použijte okraj nábytku',
    foldGuideDezeen:
      'Několikrát vytlačte prerušovanou čáru na lepence pomocí rýsovacích nástrojů, ayb se lepenka dokázala lépe ohnout.', //update
    glue: 'Na povrch ronovměrne naneste lepidlo nebo pásku', //update
    cable: 'Na propojení použijte stahovací pásky nebo šňůry', //update
    done: 'Hotovo!',
    goBack: 'Jít zpět do hlavní nabídky',
  },
  CautionPage: {
    CAUTION: 'UPOZORNĚNÍ',
    needItem: 'Budet potřebovat tyto předměty',
    children: 'Děti by měly být v přítomnosti rodičů',
    mat:
      'Prosím, položte na zem ochranné prostředky ať zabráníte poškožení podlahy.',
    doNotPutHeavyThing:
      'Nestoupejte ani nesedejte na tyto předměty, také je nepřetěžujte ostatními předměty.',
    doNotThrow:
      'Neházejte ani nekopejte s předměty',
    stayAwayFlame: 'Chraňte před ohněm',
    stayAwayWater: 'Není vhodné umisťovat v prostoru blízko vody a do vlhkého prostředí',
    mayDamaged: '* TV krabice mohou být poškozené v důsledku přepravního procesu.',
    companyDoestResponsible:
      '* Společnost nenese zodpovědnost za zranění a úrazy sppojene s touto činností.',
    cannotBeReturned:
      '*Produkt s poškozenou krabicí nemůže být vrácený pro problémy spojené s jeho kvalitou.',
    understand: 'Ano, rozumím',
  },
  PrivacyPolicy: {
    title: 'Zásady ochrany osobních údajů',
  },
  GoingGreen: {
    visual: {
      title: 'Going Green',
      text1:
        'V porovnání s našimi předchozími obaly využíváme méně papíru a inkoustu. Záleží nám na životním prostředí a proto inovujeme balení s ohledem na naší planetu.',
      text2:'',
      text2_special:
        '(*Výše uvedené neplatí u všech modelů včetně lifestylových televizorů)',
      text3: 'Zvolte tlačítko níže a dozvíte se víc',
    },
    greenIn: {
      title: 'Jsme Eko v TV obalech',
      subtitle1: 'Vyhledat informace o produktu',
      subtitle2: 'Upcycling Eko balení',
      desc: 'Pro více informací vyhledejte model televizoru',
      descM: '*Vyfoťte fotografii televizoru a jeho modelového čísla.',
      guide: 'název modelu',
      button: 'Vyfotit',
      button2: 'Přejít na výrobu předmětů',
      product_info: 'Informace o produktu',
    },
    search: {
      guide: 'Vyhledat',
      noResult: 'Žádné výsledky',
      more: 'VÍCE',
      search: 'Vyhledat',
      retake: 'Opakovat ',
      result: 'Výsledek',
    },
    photo: {
      guide1: 'Napište model televizoru do určeného pole',
      guide2: '(např. Q800A, UT7000, RU7100 atd.)',
    },
  },
  searchCountrySelect: 'Zvolte zemi'
};
